<template>
  <div>
    <template v-for="(item, index) in data">
      <el-submenu :key="index" :index="item.path" v-if="item.children?.length > 0">
        <template slot="title">
          <!-- <i :class="item.meta?.icon"></i> -->

          <img :src="item.meta?.icon" alt="">
          <span style="margin-left: 5px;">{{ item.meta?.title }}</span>
        </template>
        <el-menu-item-group>
          <myitem :data="item.children"></myitem>
        </el-menu-item-group>
      </el-submenu>
      <!-- 情况二：没子集的情况： -->
      <el-menu-item :key="item.path" v-else :index="item.path">
        <!-- <i :class="item.meta?.icon"></i> -->
        <img v-if="item.meta?.icon" style="width: 20px; height: 20px;" :src="item.meta?.icon" alt="">
        <span style="margin-left: 5px;" slot="title">{{ item.meta?.title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "myitem",
  props: ["data"],
  methods: {
    // toPath(item) {
    //   this.$router.push(item.path)
    // }
  }
};
</script>
<style lang="scss"></style>
